import { Route } from 'kts-platform-frame/routes';
import UIComponents from './UI.Components';
import UIDetail from './UI.Detail';
import UICreate from './UI.Create';

const parentName: string = 'OutputSettlement'; // 路由的跟节点；
Route.addNode(
    parentName,
    { nodeName: 'OutputSettlement',exact:true, path: '*/OutputSettlement', component: UIComponents },
    { nodeName: 'Outputsettlementdetail',exact:true, path: '*/OutputSettlement/detail', component:UIDetail },
    { nodeName: 'Outputsettlementlist',exact:true, path: '*/OutputSettlement/detail/makeInvoice', component: UICreate },
);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    }
};

export {
    Switch
} from 'react-router-dom';


// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/Modules.Route.tsx